import React from "react";
import styles from "./slider.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./swiper.css";
import { Navigation } from "swiper/modules";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Link } from "react-router-dom";
import { LightBgButton } from "../Buttons/LightBgButton";

const SliderTestimonial = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section} id="program">
        <Container>
          <LightBgButton label={'Testimonials'} bg="#CCD7FF" color="var(--primary-color)" />
          <div className={styles.aboutChild}>
            <Row>
              <Col md={6} sm={12}>
                <div >
                  <Heading>What Our Clients Say</Heading>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className={styles.rightSection}>
                  <Paragraph>
                  Whether you’re just starting or scaling your venture, our structured programs ensure you receive expert guidance and resources to overcome challenges.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <Container>
          <Swiper
            slidesPerView={2.5}
            spaceBetween={50}
            navigation={true}
            modules={[Navigation]}
            breakpoints={{
              320: { slidesPerView: 1 },
              480: { slidesPerView: 1 },
              768: { slidesPerView: 2.5 },

            }}
            className={`mySwiper ${styles.swiper_section}`}
          >
            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/rating.png" 
                alt="Client testimonials - Buildshell" />
                  <p>Amazing experience working with Buildshell ! They built our platform from scratch, and the UI/UX was simply outstanding!</p>
                  <Link to="#">Tutorazzi’s Co-Founder</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/rating.png" 
                alt="Client testimonials - Buildshell" />
                  <p>They delivered an enterprise software solution that transformed our business operations. Highly recommend!</p>
                  <Link to="#">Founder of Homeserve</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/rating.png" 
                alt="Client testimonials - Buildshell" />
                  <p>The best tech partner we’ve worked with. Fast delivery, great designs, and excellent support.</p>
                  <Link to="#">Founder OF Consolegal</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/rating.png" 
                alt="Client testimonials - Buildshell" />
                  <p>Amazing experience working with Buildshell ! They built our platform from scratch, and the UI/UX was simply outstanding!</p>
                  <Link to="#">Tutorazzi’s Co-Founder</Link>
              </div>
            </SwiperSlide>

          </Swiper>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SliderTestimonial;
